var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e49c219829d5336f347c2d70f023ea2649631b34"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["tangible-growth@tangible-growth"]={id:"e49c219829d5336f347c2d70f023ea2649631b34"};
      